module.exports = __webpack_public_path__ + "media/images/articles/resume/mv_img_01-8395843a82733349c1b1cf446677abbc.png";